import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import TutorPortal from './components/user/TutorPortal';
import TutorLandingPage from './components/user/TutorLandingPage';
import StripeCheckout from './components/business/StripeCheckout';
import Login from './components/business/Login';
import { Analytics } from "@vercel/analytics/react";
import Tos from './components/business/Tos';
import Contact from './components/business/Contact';
import StudentPortal from './components/student/StudentPortal';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Analytics />
        <Routes>
          {/* Landing page as the default route */}
          <Route path="/" element={<TutorLandingPage />} />
          <Route path="/tos" element={<Tos/>}/>
          <Route path="/contact" element={<Contact/>}/>
          
          {/* Login route */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes that require authentication */}
          <Route path="/portal" element={
            <ProtectedRoute>
              <TutorPortal />
            </ProtectedRoute>
          } />

          <Route path="/student" element={
            <StudentPortal />
          } />
          
          <Route path="/checkout" element={
            <ProtectedRoute requiresSubscription={false}>
              <StripeCheckout />
            </ProtectedRoute>
          } />
          
          {/* Redirect /signup to the login page */}
          <Route path="/signup" element={<Navigate to="/login" />} />
          
          {/* Additional informational routes that map to sections on landing page */}
          <Route path="/features" element={<Navigate to="/#features" />} />
          <Route path="/pricing" element={<Navigate to="/#pricing" />} />
          <Route path="/testimonials" element={<Navigate to="/#testimonials" />} />
          <Route path="/faq" element={<Navigate to="/#faq" />} />
          
          {/* Catch-all route - redirects to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;